import { createMuiTheme } from '@material-ui/core/styles';

// Same palette as the public frontend (frontend/.../ProjectsIIRSA/index.tsx)
export const appTheme = createMuiTheme({
  palette: {
    primary: {
      light: '#FAFAFA',
      main: '#004A73'
    },
    secondary: {
      main: '#90cc94'
    }
  },
  typography: {
    fontFamily: ['Archivo', 'Arial', 'Helvetica', 'sans-serif'].join(',')
  }
});
